export const environment = {
  production: false,
  vvcrUrl: 'https://dev.vvcr.tv'
};
